import { UPDATE_THRESHOLDS } from '../../constants/appTypes';

const initialState: any = {};

interface rasterThresholdsAction {
  thresholdValue: Array<number>;
  min: number;
  max: number;
  layerId: string;
  type: string;
  count: number;
}

export function rasterThresholds(state = initialState, action: rasterThresholdsAction) {
  switch (action.type) {
    case UPDATE_THRESHOLDS:
      const clonedState = { ...state };
      clonedState[action.layerId] = {
        thresholdValues: action.thresholdValue,
        min: action.min,
        max: action.max,
        count: action.count,
      };
      return clonedState;
    default:
      return state;
  }
}

export default rasterThresholds;
